import React from 'react'

import { AppContext } from '@/components/base/appcontext'
import { useReferrerBack } from '@/hooks/useReferrerBack'

import { Button } from '@/components/ui/button'

type BackButtonProps = {
    slug?: string
    size?: 'sm' | 'default' | 'lg'
    variant?:
        | 'default'
        | 'secondary'
        | 'outline'
        | 'ghost'
        | 'destructive'
        | 'link'
    disabled?: boolean
    isFullWidth?: boolean
}

function BackButton({
    slug,
    size,
    variant = 'default',
    disabled,
    isFullWidth
}: BackButtonProps) {
    const appContext = React.useContext(AppContext)
    const handleBack = useReferrerBack()

    return (
        <Button
            size={size}
            className={isFullWidth ? 'w-full' : undefined}
            disabled={disabled}
            variant={variant}
            type="button"
            onClick={handleBack}
        >
            {appContext.geti18n(slug || 'base.error.button.back.text')}
        </Button>
    )
}

export default BackButton
